/**
 * «Заменить картинку» из быстрого тулбара составного блока. Тулбар и картинка живут
 * в разных ветках дерева, а окно выбора файла открывает зона загрузки картинки
 * (`CanvasImageFilled`) — тулбар только просит её об этом по id элемента.
 */
type Listener = (elementId: string) => void

const listeners = new Set<Listener>()

export const requestImageReplace = (elementId: string) => {
  listeners.forEach((l) => l(elementId))
}

export const onImageReplaceRequest = (listener: Listener) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}
